module.exports = __webpack_public_path__ + "img/peacefulvalley.3e80b49b.png";